import { usePage } from '@inertiajs/react'
import type { SharedProps } from '@/shared/types/SharedProps'
import type { Resource, Action } from '@/shared/rbac'
import { Actions } from '@/shared/rbac'

export const READ_ONLY_ACTIONS: ReadonlySet<Action> = new Set([Actions.READ])

export function useCan(resource: Resource, action: Action): boolean {
  const { permissions, currentUserInfo } = usePage<SharedProps>().props
  if (currentUserInfo?.viewOnly && !READ_ONLY_ACTIONS.has(action)) return false
  return permissions?.[resource]?.includes(action) ?? false
}
